// Duration + label helpers

export function fmtDuration(seconds) {
  if (seconds == null) return "—";
  seconds = Math.max(0, Math.round(seconds));
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const parts = [];
  if (d) parts.push(`${d}d`);
  if (h) parts.push(`${h}h`);
  if (m || (!d && !h)) parts.push(`${m}m`);
  return parts.join(" ");
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const dt = new Date(iso);
  return dt.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
}

export const PRIORITY_STYLES = {
  LOW: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 border border-slate-300 dark:border-slate-600",
  MEDIUM: "bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300 border border-amber-300 dark:border-amber-800",
  HIGH: "bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300 border border-red-300 dark:border-red-800",
};

export const SLA_STYLES = {
  NOT_STARTED: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 border border-slate-300 dark:border-slate-600",
  IN_PROGRESS: "bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300 border border-blue-300 dark:border-blue-800",
  AT_RISK: "bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300 border border-amber-300 dark:border-amber-800",
  MET: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800",
  BREACHED: "bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300 border border-red-300 dark:border-red-800",
};

export const SLA_LABELS = {
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "On Track",
  AT_RISK: "At Risk",
  MET: "Met",
  BREACHED: "Breached",
};

export const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
